import { playerToKey, parsePlayerKey } from '../utils/playerKey.js';
import { decodeHtmlEntities } from '../utils/decodeHtmlEntities.js';

function normName(name) {
  return decodeHtmlEntities(String(name || '')).trim().toLowerCase();
}

/**
 * Classifica i target dello Studio rispetto alla lista giocatori corrente.
 * @param {Array<{playerKey:string, missing:boolean}>} targets
 * @param {Array<object>} allPlayers
 * @returns {{ok:string[], recovered:string[], changedTeam:Array<object>, missing:string[]}}
 */
export function reconcileStudioTargets(targets, allPlayers) {
  const empty = { ok: [], recovered: [], changedTeam: [], missing: [] };
  if (!Array.isArray(allPlayers) || allPlayers.length === 0) return empty;
  if (!Array.isArray(targets) || targets.length === 0) return empty;

  const presentKeys = new Set();
  const byName = new Map();
  for (const p of allPlayers) {
    const key = playerToKey(p);
    if (!key) continue;
    presentKeys.add(key);
    const n = normName(p.name);
    if (!byName.has(n)) byName.set(n, []);
    byName.get(n).push(key);
  }

  const result = { ok: [], recovered: [], changedTeam: [], missing: [] };
  for (const t of targets) {
    const oldKey = t.playerKey;
    if (!oldKey) continue;
    if (presentKeys.has(oldKey)) {
      if (t.missing) result.recovered.push(oldKey);
      else result.ok.push(oldKey);
      continue;
    }
    const parsed = parsePlayerKey(oldKey) || {};
    const n = normName(parsed.name);
    const candidates = (byName.get(n) || []).filter((k) => k !== oldKey);
    if (candidates.length === 1) {
      const newKey = candidates[0];
      const np = parsePlayerKey(newKey) || {};
      result.changedTeam.push({
        oldKey,
        newKey,
        name: parsed.name,
        oldTeam: parsed.team,
        newTeam: np.team,
      });
    } else {
      result.missing.push(oldKey);
    }
  }
  return result;
}
